// NTTO-deelnemers zijn verdeeld over secties, elk met eigen klassen. Farm Stock
// komt uit de `klassen`/`deelnperwedstrijd`-tabellen; Grand National, Trucks en
// Nationaal uit `klassenadivisie` + `tbl_uitslagen_gn`.
export type SectieCode = "farmstock" | "gn" | "trucks" | "nationaal" | "overig";

export const SECTIE_LABEL: Record<SectieCode, string> = {
  farmstock: "Farm Stock",
  gn: "Grand National",
  trucks: "Trucks",
  nationaal: "Nationaal",
  overig: "Overig",
};

export const SECTIE_VOLGORDE: SectieCode[] = ["farmstock", "gn", "trucks", "nationaal", "overig"];

// Farm Stock-rijders zitten in `deelnemers` (/rijder), de overige secties in
// `deelnemersa` (/gn-rijder). Aparte id-ruimtes, dus aparte routes.
export function rijderHref(code: SectieCode, deelnID: number | null): string | null {
  if (deelnID == null) return null;
  return code === "farmstock" ? `/rijder/${deelnID}` : `/gn-rijder/${deelnID}`;
}

export function sectieVanDivisie(divisie: string | null): SectieCode {
  switch ((divisie ?? "").trim().toUpperCase()) {
    case "GN":
      return "gn";
    case "T":
      return "trucks";
    case "N":
      return "nationaal";
    default:
      return "overig";
  }
}

// Voor favorieten telt alleen in welke tabel iemand staat: Farm Stock in
// `deelnemers`, de rest in `deelnemersa`. Dat is dezelfde tweedeling als bij
// rijderHref, maar met de codes die de opslag gebruikt.
export function favorietSectie(code: SectieCode): "fs" | "gn" {
  return code === "farmstock" ? "fs" : "gn";
}
